module.exports = "img/flags/NA.72c1ee9.png";